module.exports = __webpack_public_path__ + "static/media/avatar.19e749cd.svg";